module.exports = __webpack_public_path__ + "img/5.b0e108fe.jpg";